import React from 'react';
import { CheckSquare, X, ArrowRightLeft, XCircle } from 'lucide-react';
interface BulkActionBarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onReassign: () => void;
  onCloseEscalation: () => void;
}
export function BulkActionBar({
  selectedCount,
  onClearSelection,
  onReassign,
  onCloseEscalation
}: BulkActionBarProps) {
  if (selectedCount === 0) return null;
  return <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40" data-id="element-1">
      <div className="bg-gray-900 text-white px-4 py-3 rounded-2xl shadow-2xl flex items-center gap-6 border border-gray-800" data-id="element-2">
        <div className="flex items-center gap-3 pl-2" data-id="element-3">
          <div className="bg-blue-500/20 text-blue-400 p-1.5 rounded-md" data-id="element-4">
            <CheckSquare className="w-4 h-4" data-id="element-5" />
          </div>
          <span className="font-medium text-sm" data-id="element-6">
            {selectedCount} loan{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>

        <div className="w-px h-6 bg-gray-700" data-id="element-7"></div>

        <div className="flex items-center gap-2" data-id="element-8">
          <button onClick={onReassign} className="flex items-center gap-2 px-3 py-1.5 bg-white text-gray-900 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors" data-id="element-9">
            <ArrowRightLeft className="w-4 h-4" data-id="element-10" />
            Move to Retention
          </button>
          <button onClick={onCloseEscalation} className="flex items-center gap-2 px-3 py-1.5 text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg text-sm font-medium transition-colors" data-id="element-11">
            <XCircle className="w-4 h-4" data-id="element-12" />
            Close Escalation
          </button>
        </div>

        <div className="w-px h-6 bg-gray-700" data-id="element-13"></div>

        <button onClick={onClearSelection} className="p-1.5 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors" aria-label="Clear selection" data-id="element-14">
          <X className="w-5 h-5" data-id="element-15" />
        </button>
      </div>
    </div>;
}